//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
// teammate-health-avatar imports
import { IAddContainer, IAddProps, IAddState } from "./TeammateHealthAvatar.d";
import * as s from "./TeammateHealthAvatar.styles";
// other internals
// import { TutorialDefineTeam } from '@components/tutorial-tip';
// state
import { IReduxState } from "@reducers/root.reducer";
import { setSettingsDialogOpen } from "@actions/chrome-extension.actions";
import { openTeam } from "@actions/settings.actions";
import { track, TrackingEvents } from "@util/analytics.util";
// material-ui
import { Add } from "@material-ui/icons";

//////////////////
// COMPONENT
//////////////////
class TeammateHealthAddCmpt extends React.Component<IAddProps, IAddState> {
  private toolTipId: string;

  constructor(props: IAddProps) {
    super(props);
    this.toolTipId = `tooltip_for_teammate_add`;
    this.state = {
      hovered: false,
    };
  }

  private onHover = (hovered: boolean) => {
    this.setState({ hovered });
  };

  private onClick = () => {
    this.props.setSettingsDialogOpen(true);
    this.props.openTeam();
    if (this.props.inlineLabel) {
      // bad proxy for this being on the dashboard
      track(TrackingEvents.TEAM_HEALTH.DASHBOARD_ADD_TEAMMATE);
    } else {
      track(TrackingEvents.TEAM_HEALTH.SUMMARY_ADD_TEAMMATE);
    }
  };

  private renderTooltipContent = () => {
    return this.props.hasNotDefinedTeamYet ? (
      <div style={s.toolTipTextOnly}>
        Set up your team to get
        <br />
        insights about your teammates.
      </div>
    ) : (
      <div style={s.toolTipTextOnly}>Add or edit teammates.</div>
    );
  };

  public render() {
    const { width, inlineLabel } = this.props;
    const { hovered } = this.state;
    const color = hovered ? s.addCircleColorHovered : s.addCircleColor;
    const nameOpacity = hovered ? 1 : 0;
    const circleDimensions = {
      width: width - 12,
      height: width - 12,
    };

    const flexDirection = inlineLabel ? "row-reverse" : "column";

    return (
      <div
        style={s.container}
        onClick={() => this.onClick()}
        onMouseEnter={() => this.onHover(true)}
        onMouseLeave={() => this.onHover(false)}
        data-for={this.toolTipId}
        data-tip
      >
        <div style={{ ...s.teammate, flexDirection }}>
          <div style={{ ...s.addContainer, width, height: width }}>
            <div style={{ ...s.addCircle, ...circleDimensions }}>
              <Add style={{ width: width / 2 }} htmlColor={color} />
            </div>
          </div>
          <div
            style={{
              ...s.teammateName,
              color,
              opacity: nameOpacity,
              maxWidth: width,
              marginTop: inlineLabel ? 0 : s.teammateName.marginTop,
            }}
          >
            Add
          </div>
        </div>
        <ReactTooltip id={this.toolTipId} place="bottom" effect="solid">
          {this.renderTooltipContent()}
        </ReactTooltip>
      </div>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IAddContainer) {
  return {};
}

export const TeammateHealthAdd = connect(mapStateToProps, {
  setSettingsDialogOpen,
  openTeam,
})(TeammateHealthAddCmpt);
